var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDriver2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.336 1.947v5.54c0 .68-.553 1.233-1.233 1.233h-6.1a.669.669 0 0 1-.667-.667v-4.26c0-1.36 1.1-2.46 2.46-2.46h4.92c.347 0 .62.274.62.614z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.336 10.333a.33.33 0 0 1 .333.334v.666c0 1.107-.893 2-2 2 0-1.1-.9-2-2-2s-2 .9-2 2H7.336c0-1.1-.9-2-2-2s-2 .9-2 2c-1.107 0-2-.893-2-2V10c0-.367.3-.667.667-.667h6.333c.92 0 1.667-.746 1.667-1.666V4c0-.367.3-.667.666-.667h.56c.48 0 .92.26 1.16.674l.427.746a.168.168 0 0 1-.147.247c-.92 0-1.666.747-1.666 1.667v2c0 .92.746 1.666 1.666 1.666h1.667z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667zM10.67 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667zM14.667 8.353v.98h-2A.669.669 0 0 1 12 8.667v-2c0-.367.3-.667.667-.667h.86l.966 1.693c.114.2.174.427.174.66z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriver2);
export default __webpack_public_path__ + "static/media/ic-driver2.af783bf186484af6e442ef8108fe4db4.svg";
export { ForwardRef as ReactComponent };